import { API_v2 } from '@/services/config';
import { request } from '@@/exports';

/**
 * 获取公司下的项目列表
 * @param params
 * @param options
 */
export async function getProjectListWithCompany(
  params: {
    /** current */
    page?: number;
    /** pageSize */
    pageSize?: number;
    // 公司id
    company_id?: number | string;
    // 1 代表 普通项目 2 代表公司日常管理项目
    is_company?: number | string;
  },
  options?: { [key: string]: any },
) {
  return request(API_v2.getProjectListWithCompany, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}
/**
 * 获取项目负责人列表
 * @param params
 * @param options
 */
export async function getProjectPrincipalList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
    query_all?: string;
    principal_name?: string;
    project_principal?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getProjectPrincipalList, {
    method: 'GET',
    params,
    ...(options || {}),
  });
}
/**
 * 修改项目负责人信息
 * @param data
 * @param options
 */
export async function editProjectPrincipal(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_personnel_id?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.editProjectPrincipal, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 添加项目负责人
 * @param data
 * @param options
 */
export async function addProjectPrincipal(
  data: {
    page?: number;
    pageSize?: number;
    field_name: string;
    ids: number[];
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.addProjectPrincipal, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 删除项目负责人
 * @param data
 * @param options
 */
export async function delProjectPrincipal(
  data: {
    page?: number;
    pageSize?: number;
    field_name?: string;
    project_principal_id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.delProjectPrincipal, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 获取项目列表
 * @param params
 * @param options
 */
export async function getProjectList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
    is_company?: string;
    query_all?: string;
    project_principal?: string | null;
    project_tags?: string;
    not_me?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getProjectList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 获取删除的项目列表
 * @param params
 * @param options
 */
export async function getProjectDelList(
  params: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    company_id?: string;
    is_company?: string;
    query_all?: string;
    project_principal?: string | null;
    deleted?: string | number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.getProjectDelList, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params,
    ...(options || {}),
  });
}
/**
 * 修改项目信息
 * @param data
 * @param options
 */
export async function editProject(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    project_id?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.editProject, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 修改项目状态
 * @param data
 * @param options
 */
export async function updateProjectStatus(
  data: {
    page?: number;
    pageSize?: number;
    current?: number;
    keyword?: string;
    project_id?: number;
    project_status?: number;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.updateProjectStatus, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 添加项目
 * @param data
 * @param options
 */
export async function addProject(
  data: {
    page?: number;
    pageSize?: number;
    field_name: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.addProject, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 删除项目
 * @param data
 * @param options
 */
export async function delProject(
  data: {
    page?: number;
    pageSize?: number;
    field_name?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.delProject, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
/**
 * 恢复项目
 * @param data
 * @param options
 */
export async function recoverProject(
  data: {
    page?: number;
    pageSize?: number;
    field_name?: string;
    project_id?: string;
    id?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.recoverProject, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}

/**
 * 新增收款记录
 * @param data
 * @param options
 */
export async function addContractReceiptRecord(
  data: {
    page?: number;
    pageSize?: number;
    field_name?: string;
    project_id?: string;
    contract_id?: string;
    amount?: number;
    pay_cause?: string;
    pay_account?: string;
    pay_account_name?: string;
  },
  options?: { [key: string]: any },
) {
  // 执行实际的 API 请求
  return request(API_v2.addContractReceiptRecord, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
    ...(options || {}),
  });
}
